// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__xAMJz","Spinner":"Loader_Spinner__gmGvM","spin":"Loader_spin__WwiV4","Message":"Loader_Message__ng2RK"};